import { Box, Icon } from '@chakra-ui/react';
import { FC } from 'react';
import { CloseMenu, HamMenu } from '../../../assets';

export interface HeaderMenuToggleProps {
  toggle: () => void;
  isOpen: boolean;
}

export const HeaderMenuToggle: FC<HeaderMenuToggleProps> = ({
  toggle,
  isOpen,
}) => (
  <Box pr={4} display={{ base: 'block', md: 'none' }} onClick={toggle}>
    {isOpen ? (
      <Icon as={CloseMenu} boxSize="24px" />
    ) : (
      <Icon as={HamMenu} boxSize="24px" />
    )}
  </Box>
);
